export const siteModuleKeys: string[] = [
  'bios',
  'blog',
  'careers',
  'cities',
  'documents',
  'faqs',
  'form_settings',
  'inquiries',
  'menu_editor',
  'news',
  'pages',
  'site_management',
  'panels',
  'testimonials',
];

export const postModuleKeys: string[] = [
  'bios',
  'blog',
  'careers',
  'documents',
  'faqs',
  'news',
  'testimonials',
];

export const propertyModuleKeys: string[] = [
  'building_photos',
  'promotions',
  'maintenance',
  'waitinglist',
  'featured',
  'floorplan_navigator',
];

export const generalModuleKeys: string[] = [
  'accounting',
  'buildings',
  'call_tracking',
  'insights',
  'lead_tracker',
  'rentsync',
  'promoted_listings',
  'tour_admins_agents',
  'custom_reporting',
  'premium_reporting',
];
